module.exports = __webpack_public_path__ + "img/clear.426c598a.svg";